import React, { useState } from "react";
import { Plus } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { CategoryEntityType } from "@/types/category";
import { CategoryModal } from "./CategoryModal";

interface CreateCategoryButtonProps {
  entityType: CategoryEntityType;
}

export const CreateCategoryButton: React.FC<CreateCategoryButtonProps> = ({
  entityType,
}) => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Button
        variant="new_default"
        onClick={() => setIsModalOpen(true)}
        title={t("categories:createCategory")}
      >
        <Plus />
        {t("categories:createCategory")}
      </Button>

      <CategoryModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        entityType={entityType}
      />
    </>
  );
};
